import { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

// Check-in obligatoire : politique + cours du jour terminés sans check-in au kiosque.
export default function CheckinPolicyPanel() {
  const [pol, setPol] = useState(null);
  const [gaps, setGaps] = useState(null);
  const load = useCallback(() => {
    api.get("/attendance/checkin-policy").then((r) => setPol(r.data)).catch(() => {});
    api.get("/attendance/checkin-gaps").then((r) => setGaps(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!pol) return null;
  const toggle = async () => {
    try { await api.put("/attendance/checkin-policy", { ...pol, required: !pol.required }); toast.success(!pol.required ? "Check-in obligatoire ACTIVÉ" : "Check-in obligatoire désactivé"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Échec"); }
  };
  return (
    <div className={`mt-4 border p-4 ${pol.required ? "border-emerald-500/40 bg-emerald-500/5" : "border-amber-500/40 bg-amber-500/5"}`} data-testid="checkin-policy-panel">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="text-sm">
          <div className="font-bold flex items-center gap-2"><ShieldCheck size={16} className={pol.required ? "text-emerald-400" : "text-amber-400"} /> Check-in obligatoire à chaque cours</div>
          <p className="text-xs text-white/50 mt-0.5">Chaque élève scanne au kiosque en arrivant : c'est la seule façon de mesurer les présences moyennes du mois. Audit chaque soir 22 h : les cours terminés sans check-in te sont envoyés par courriel.</p>
        </div>
        <button onClick={toggle} data-testid="checkin-policy-toggle" className={`text-xs px-3 py-1.5 border ${pol.required ? "border-emerald-500/40 text-emerald-300 bg-emerald-500/10" : "border-amber-500/40 text-amber-300 bg-amber-500/10"}`}>
          {pol.required ? "OBLIGATOIRE" : "FACULTATIF"}
        </button>
      </div>
      {gaps && (
        <div className="mt-3 text-xs" data-testid="checkin-gaps">
          <span className="text-white/60">{gaps.jour} {gaps.date} · {gaps.total_checkins} check-in{gaps.total_checkins > 1 ? "s" : ""} · {gaps.courses.length} cours terminé{gaps.courses.length > 1 ? "s" : ""}</span>
          {gaps.gaps.length === 0 ? <span className="ml-2 text-emerald-300">— aucun cours sans check-in ✅</span> : (
            <ul className="mt-1 flex flex-wrap gap-1.5">{gaps.gaps.map((g) => <li key={g.course_id || g.titre} className="border border-rose-500/40 bg-rose-500/10 text-rose-200 px-2 py-0.5" data-testid="checkin-gap">{g.titre} · {g.heure} · {g.checkins} check-in</li>)}</ul>
          )}
        </div>
      )}
    </div>
  );
}
